// extracted by mini-css-extract-plugin
export var downArrow = "_ay-0";
export var label = "_ay-1";
export var treatmentCard = "_ay-3";
export var upArrow = "_ay-2";